export default function ScoringExplainer({ showAiSection = true }: { showAiSection?: boolean }) {
  return (
    <div className="space-y-3">
      <p>
        Each answer option can have a <strong>score</strong>. When a lead submits the form, their
        total score is compared against the maximum possible score to automatically set their priority.
      </p>
      <div className="rounded-lg bg-gray-50 p-3 text-xs">
        <div className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1">
          <span className="font-semibold text-rose-600">Hot</span>
          <span>Score is 70% or more of the maximum</span>
          <span className="font-semibold text-amber-600">Warm</span>
          <span>Score is between 30% and 70%</span>
          <span className="font-semibold text-sky-600">Cold</span>
          <span>Score is below 30%</span>
        </div>
      </div>
      <p>
        <strong>Single-select questions:</strong> the selected option's score is used.
      </p>
      <p>
        <strong>Multi-select questions:</strong> all selected option scores are added together.
        Max possible = sum of all option scores.
      </p>
      <p>
        Questions where all options have a score of 0 are ignored in the calculation. If no questions have
        scores configured, leads default to <strong>Warm</strong>.
      </p>
      <p className="text-black/40">
        Priority is auto-calculated when a lead first submits the form. Manual edits from the dashboard are preserved.
      </p>
      {showAiSection && (
        <>
          <hr className="border-gray-200" />
          <p>
            <strong>AI-suggested scores</strong>
          </p>
          <p>
            Once you have won deals, click <strong>"Suggest scores from win data"</strong> to let AI
            analyze which answers correlate with winning. It looks at all leads across every event that
            uses the template, compares answer patterns of won leads vs all leads, and suggests a 1-10
            score for each option with an explanation.
          </p>
          <p>
            Suggestions are shown for review before applying — you decide whether to accept them.
            Applied scores update the template only; existing events keep their current scores.
            New events imported from the template will use the updated scores.
          </p>
          <p className="text-black/40">
            A minimum of 5 won leads is recommended for reliable suggestions. Fewer than that will
            still work but a warning is shown.
          </p>
        </>
      )}
    </div>
  )
}
